module.exports = __webpack_public_path__ + "static/img/10kula3D.7021f486.png";